import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';

export interface CourierZone {
  id: number;
  country_id: number;
  name: string;
  code: string;
  name_es: string;
  is_active: boolean;
}

export const useCourierZones = (countryId: string | null) => {
  const httpClient = createHttpClient(apiClientWH);

  return useQuery<CourierZone[]>({
    queryKey: ['courier-zones', countryId],
    queryFn: async () => {
      if (!countryId) return [];
      const response = await httpClient.get<CourierZone[]>(
        `/courier-zones/country/${countryId}`,
        {},
        {},
        false
      );
      return Array.isArray(response) ? response : [];
    },
    enabled: !!countryId,
    staleTime: 5 * 60 * 1000,
  });
};

